













import {
  defineComponent,
  computed,
  useRoute,
  ref,
  watchEffect
} from '@nuxtjs/composition-api';

import { usePageStore } from '~/stores/page';
import CATEGORY from '~/modules/catalog/pages/category.vue';
import CMS_PAGE from '~/pages/Cms.vue';
import PRODUCT from '~/modules/catalog/pages/product.vue';

import { getMetaInfo } from '~/helpers/getMetaInfo';

import { usefetchRouterCheck } from '~/components/czar/homePage/routeCheck';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import ProductSkeleton from '~/modules/catalog/product/components/ProductSkeleton.vue';

export default defineComponent({
  name: 'PageResolver',
  components: {
    CATEGORY,
    CMS_PAGE,
    PRODUCT,
    SkeletonLoader,
    ProductSkeleton
  },
  middleware: ['url-resolver'],

  setup() {
    const route = useRoute();
  const { routeDataMeta } = usePageStore();
  const fetchRouterCheck = usefetchRouterCheck();

  const routerDataRes = ref(null);
  const type = computed(() => routerDataRes.value?.type);

  watchEffect(async () => {
    await fetchRouterCheck.fetchRouterCheck({ url: route?.value?.fullPath });
    routerDataRes.value = fetchRouterCheck?.routerDataRes?.route;
  });

  return {
    type,
    routerDataRes,
    routeDataMeta
  };
  },
  head() {
    return getMetaInfo(this.routeDataMeta);
  },
});
